import React from "react";
import Card from "react-bootstrap/Card";


function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi my name is <strong className="purple">Diyon Shibu </strong>
            and Im from <strong className="purple"> Ireland.</strong>
            <br />Im a 15 year old Web Developer. I create websites and apps at an enterprice level.
            In my spare time I like to create solutions for everyday problems I face. Im interested in Moblie development using  <strong className="purple">React Native</strong> Im also interested in building bots using <strong className="purple"> Javascript and Python</strong>.
            I have a passion in developing <strong className="purple"> Enterprice</strong> software for startups and large scale companies. Im currently learning <strong className="purple">React Native </strong>.
            <br />
            <br />
          </p>

          <p style={{ marginBlockEnd: 0, color: "rgb(155 126 172)" }}>
          {" "}
          </p>
          <footer className="blockquote-footer"></footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
